import { render, staticRenderFns } from "./c-modal.vue?vue&type=template&id=df063fb4&scoped=true&"
import script from "./c-modal.vue?vue&type=script&lang=js&"
export * from "./c-modal.vue?vue&type=script&lang=js&"
import style0 from "./c-modal.vue?vue&type=style&index=0&id=df063fb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df063fb4",
  null
  
)

export default component.exports